import { OnInit, Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseService } from '../../shared/services/base.service';

@Component({
    selector: 'dhs-form-view-item',
    templateUrl: './form-view-item.component.html',
    styleUrls: ['./form-view-item.component.scss'],
    standalone: false
})
export class FormViewItemComponent implements OnInit {
  @Input() item: any;
  @Input() data: any;
  @Input() current_action: string;
  @Output() valueChanged = new EventEmitter<any>();
  ckeConfig = {
    allowedContent: true,
    extraPlugins: 'divarea',
    forcePasteAsPlainText: true,
    removeButtons: 'Flash,Smiley,Image,HorizontalRule,SpecialChar,PageBreak,Iframe,Save,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,SpellChecker,Scayt,NewPage,Preview,Print,Templates',
    readOnly: true
  }
  dataGridConfig = {
    "viewAll": true,
    "hideSearchBox": true,
    "hideResult": false,
    "customButtonsAllowed": false,
    "allowPagination": false,
  };
  constructor(private baseService: BaseService) { }
  ngOnInit() {
    console.log("item is as as in loop", this.item);
    if (this.item.dependents != undefined && this.item.dependents.length > 0) {
      this.valueChanged.emit({ val: this.item.value, question: this.item });
    }
    //for the case of ediatable Grid
    this.editableGridAdapter(this.item);

  }

  getValueDropdown(item) {
    if (item.controlType == "searchselect" && (item.view_key == undefined || !item.view_key)) {
      if (item.defaultsetting != undefined && item.defaultsetting.singleSelection != undefined && item.defaultsetting.singleSelection) {
        // return item.value != undefined && item.value ? item.value : "Not filled";
        if (item.options != undefined && item.options) {
          let val = item.options.find(x => x[item.getterKey] == item.value);
          if (val != undefined && val[item.getterValue] != undefined) {
            return val[item.getterValue];
          } else {
            return "Not filled";
          }
        }
      }
      else {
        return this.getVal(item.value);
      }

    }
    if (item.view_key != undefined && item.view_key && this.data != undefined) {
      //added to support nested object in case of view key
      let valToSet = this.data[item.view_key];
      if (item.view_key.includes('.')) {
        valToSet = this.data;
        let arr = item.view_key.split(".");
        for (let i = 0; i < arr.length; i++) {
          if (valToSet[arr[i]] != undefined) {
            valToSet = valToSet[arr[i]];
          }
          else {
            valToSet = "Not filled";
          }
        }
      }
      return valToSet;
    } else {
      if (item.options != undefined && item.options) {
        let val = item.options.find(x => x[item.getterKey] == item.value);
        if (val != undefined && val[item.getterValue] != undefined) {
          return val[item.getterValue];
        } else {
          return "Not filled";
        }
      }
    }

  }
  getVal(item) {
    let arr = [];
    for (let i = 0; i < item.length; i++) {
      arr.push(item[i].text);
    }
    if (arr.length) {
      return arr.join();
    } else {
      return "Not filled";
    }

  }
  modifyLabel(res,fields){
    for (let i = 0; i < res.length; i++) {
      //hidden fields should not be the part of editable grid view
      if (res[i].component != 'hidden') {
        fields.push({ "heading": res[i].label, "order": res[i].order ? res[i].order : 0, "name": res[i].view_key != undefined ? res[i].view_key : res[i].name, "type": res[i].type ? res[i].type : 'string' });
      }
    };
    return fields;
  }
  //this function converts editable grid resource into editable table format
  editableGridAdapter(item) {
    //this function runs in case of edit grid only 
    if (item.controlType != undefined && (item.controlType == 'editgrid' || item.controlType == 'dynamic-table')) {
      let fields: Array<any> = [];
      //getting the resource of editable grid
      if(item.controlType == 'editgrid'){
       this.getResource(item.resource,(cd)=>{
        item['fields'] =  this.modifyLabel(cd,fields)
       })
      }else if (item.controlType == 'dynamic-table' && item.value != undefined && item.value) {
        let val = JSON.parse(item.value);
        let rowHeader = val.tableConfig.is_rowHeader != undefined ? val.tableConfig.is_rowHeader : false;
        if (rowHeader) {
          this.modifyField(val.tableConfig.json.list.rowHeader, fields);
        }
        item['dynamicTablevalue'] = JSON.parse(item.value).tableVal;
        item['fields'] = fields;
      }else if(item && item.tabular_list && item.tabular_list.fields){
        let res = item.tabular_list.fields;
        item['fields'] =  this.modifyLabel(res,fields)
      }else{
        item['fields'] = [];
        console.log("No fields found")
      }
    }
    else if (item.controlType != undefined && item.controlType == 'daterangepicker') {
      this.dateRAngeAdapter(item);
    }
    else if (item.controlType == "radio") {
      if (item.options != undefined && item.options) {
        let val = item.options.find(x => x[item.getterKey] == item.value);
        if (val != undefined && val[item.getterValue] != undefined) {
          item.value = val.id;
        }
      }
    }
    else {
      //do nothing
    }
  }
  //this function converts daterangepicker object into viewable date range format format
  dateRAngeAdapter(item) {
    if (item.timePicker != undefined && !item.timePicker && item.singleDatePicker) {
      item['type'] = 'date';
    }
    else if (item.timePicker != undefined && item.timePicker && item.singleDatePicker) {
      item['type'] = 'datetime';
    }
    else if (item.timePicker != undefined && !item.timePicker && !item.singleDatePicker) {
      this.sortVal(item);
      item['type'] = 'compositeDate';
    }
    else if (item.timePicker != undefined && item.timePicker && !item.singleDatePicker) {
      this.sortVal(item);
      item['type'] = 'compositeDatetime';
    }
  }
  getResource(res,cb) {
    let fields: Array<any> = [];
    this.baseService.getResourceDef(res, (resourceDef) => {
      if (resourceDef) {
        fields = resourceDef.list.fields;
        cb(fields)
      }else{
        cb(fields)
      }
    });
  }
  //this is added to sort object on the basis of satrt and end
  sortVal(item) {
    //in this values are kind of hardcoded in array as start will always come first and as per the logic of our date range we have to show it like this
    if(item.value != undefined && item.value[item.startKey] != undefined && item.value[item.endKey] != undefined)
       item.value = [item.value[item.startKey], item.value[item.endKey]];
    else item.value = "";
  }
  parse(val) {
    return typeof val == 'string' ? JSON.parse(val) : val
  }

  modifyField(rowHeader, fields) {
    // {"type": res[i].type ? res[i].type : 'string' }

    fields.unshift({
      "heading": "field.val.empty",
      "name": "rowheader",
      "component": "label",
      "type": "string",
      "order": 0
    })
  }
  getValueForCheckbox(item, format) {
     try {
      let fn;
      return eval(format)(item);
    }
    catch (err) { console.log("Format issue in case of checkbox") }
  }
}